import { Iframe } from '@alf/uikit';

import styles from './index.module.css';

export const TransactionResultIframe = (props) => {
  return (
    <Iframe
      className={styles.iframe}
      allow="accelerometer; autoplay; camera; encrypted-media; gyroscope; payment"
      {...props}
    />
  );
};
